var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    { staticClass: "nav__top__login", class: _vm.containerClass },
    [
      _c(
        "a",
        {
          staticClass: "login-href",
          attrs: { href: _vm.loginUrl, "data-view": "login-container" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.toggleClicked.apply(null, arguments)
            }
          }
        },
        [_vm._v("Log in")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "nav__top__login-form" }, [
        _c(
          "form",
          {
            staticClass: "login-form",
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.formSubmitted()
              }
            }
          },
          [
            _c("h4", [_vm._v("Log into Backoffice")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.storeName,
                  expression: "storeName"
                }
              ],
              attrs: {
                name: "storename",
                type: "text",
                placeholder: "Store Name",
                autocomplete: "off",
                autocorrect: "off",
                autocapitalize: "off",
                spellcheck: "false"
              },
              domProps: { value: _vm.storeName },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.storeName = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              { attrs: { id: "backoffice-login-submit", for: "login-submit" } },
              [_vm._v("Log in")]
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }